import RadioFieldset from "../../audi-ui-components/RadioFieldset";
import DealerByPostcodeModule from "../../components/DealerByPostcodeModule";
import { newOwnerTypes } from "./CVOConstants";
import { gtmPush } from "../../functions/gtm";
import { DEFAULT_THEME } from "../../constants";

const StepNewOwnerDetails = ({ values, errors, touched, setFieldValue, setFieldTouched, theme = DEFAULT_THEME }) => {
  return (
    <div>
      <p className="aui-headline-4 mb-4">Who did you sell this vehicle to?</p>
      <RadioFieldset name="newOwnerType"
        options={[
          {label: newOwnerTypes.PRIVATE, value: newOwnerTypes.PRIVATE},
          {label: newOwnerTypes.AUDI, value: newOwnerTypes.AUDI},
          {label: newOwnerTypes.DEALER, value: newOwnerTypes.DEALER},
        ]}
        value={values.newOwnerType}
        onChange={(v) => {
          setFieldValue('newOwnerType', v);
          gtmPush("cvoWhoSoldTo", "ChangeVehicleOwnership", v);
        }}
        onBlur={() => { setFieldTouched('newOwnerType'); }}
        isInvalid={errors.newOwnerType && touched.newOwnerType}
        invalidMessage={errors.newOwnerType}
        className="form-field"
        theme={theme === "dark" ? "light" : null}
      />
      {values.newOwnerType === newOwnerTypes.PRIVATE && <div>
        <p>Please ask the new owner to fill in this form and select "I am the new owner of this vehicle"</p>
      </div>}
      {values.newOwnerType === newOwnerTypes.AUDI && <div>
        <DealerByPostcodeModule
          title=""
          fieldDescription="Enter dealer postcode"
          postcodeLabel="Search"
          floatingLabel={false}
          values={values}
          errors={errors}
          touched={touched}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          onSelectDealer={(opt) => { gtmPush("cvoSoldToDealer", "ChangeVehicleOwnership", opt.dealer?.name); }}
          theme={theme}
        />
      </div>}
    </div>
  );
};

export default StepNewOwnerDetails;
